module.exports = __webpack_public_path__ + "img/marido-logo-612x612-no-bg.ed7f2124.png";